import styled from "styled-components";

export const WhiteCardContainer = styled.article`
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 1rem;
  width: 100%;
  background: ${(props) => props.theme.white};
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  overflow: hidden;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const WhiteCardImage = styled.img`
  width: 100%;
  height: 100%;
  min-height: 140px;
  object-fit: cover;
`;

export const WhiteCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;

  h3 {
    color: ${(props) => props.theme["gray-300"]};
    font-size: 1.125rem;
    line-height: 1.3;
  }

  p {
    color: ${(props) => props.theme["gray-100"]};
    font-size: 0.875rem;
  }
`;
